import { Button, Card, InputNumber, message, Select, Switch } from "antd";

import { getSupaClient } from "../../lib/supabase";

import { useEffect, useState } from "react";

const moment = require("moment-timezone");

/** Settings related to user level such as notifcations for Slack  */

export default function SlackUserSettings() {
  const slackId = localStorage.getItem("slack-id");
  const teamId = localStorage.getItem("team-id");

  const [dailySummary, setDailySummary] = useState(true);
  const [weeklySummary, setWeeklySummary] = useState(true);

  const [teamTimezone, setTeamTimezone] = useState<string | null>(null);

  const [timezone, setTimezone] = useState<string | null>(null);
  type Settings = {
    work_hours: { start_hour: null; end_hour: null };
    timezone?: any;
    start_time?: any;
    frequency?: any;
    postDay?: any;
  };
  const [settingsObj, setSettingsObj] = useState<Settings>({
    work_hours: { start_hour: null, end_hour: null },
  });
  const { Option } = Select;
  const timezones = moment.tz.names();
  const supaClient = getSupaClient();

  const onDailySummary = async (checked: boolean) => {
    // console.log(`switch to ${checked}`);
    const { data, error } = await supaClient
      .from("users")
      .update({ settings_daily_slack_digest_subscribed: checked })
      .eq("slack_id", slackId);
    if (data) {
      // console.log("data", data);
      setDailySummary(checked);
      message.success("Daily summary settings saved!");
      window.analytics.track("Weekly summary settings changed");
    }
    if (error) {
      message.info("Please try again");
    }
    return data;
  };

  // Loads the team time zone
  const loadTeamTimezone = async () => {
    const { data, error } = await supaClient
      .from("teams")
      .select("timezone")
      .eq("slack_id", teamId);

    if (data) {
      setTeamTimezone(data[0].timezone);
    }
    if (error) {
      console.log("Error", error);
    }
  };

  const onWeeklySummary = async (checked: boolean) => {
    // console.log(`switch to ${checked}`);
    const { data, error } = await supaClient
      .from("users")
      .update({
        settings_unsubscribed_weekly_email_digest: !checked,
      })
      .eq("slack_id", slackId);
    if (data) {
      // console.log("data", data);
      setWeeklySummary(checked);
      message.success("Weekly summary settings saved!");
      window.analytics.track("Weekly summary settings changed");
    }
    if (error) {
      message.info("Please try again");
    }
    return data;
  };
  /**
   * Purpose: Load user settings
   * Params
   */
  const loadUserSettings = async () => {
    const settings = await supaClient
      .from("users")
      .select(
        "settings_daily_slack_digest_subscribed, settings_unsubscribed_weekly_email_digest, timezone, settings, weekly_at_risk_message_enabled"
      )
      .eq("slack_id", slackId);
    // console.log("settg", settings);
    if (settings.data && settings.data[0]) {
      setDailySummary(settings.data[0].settings_daily_slack_digest_subscribed);
      // since this takes in false to actually enable emails, we set it opposite
      setWeeklySummary(
        !settings.data[0].settings_unsubscribed_weekly_email_digest
      );

      setSettingsObj(settings.data[0].settings);
      if (settings.data[0].timezone) {
        setTimezone(settings.data[0].timezone);
      }
    }
    return settings;
  };

  // check if the user has a strip customer id
  useEffect(() => {
    document.title = "Settings | Dots";
    loadUserSettings();

    loadTeamTimezone();
  }, []);

  const handleChangeTimeZone = (value: string) => {
    setTimezone(value);
  };

  const handleChangeTimeStart = (value: any) => {
    setSettingsObj({
      ...settingsObj,
      work_hours: {
        ...settingsObj.work_hours,
        start_hour: value,
      },
    });
  };

  const handleChangeTimeEnd = (value: any) => {
    setSettingsObj({
      ...settingsObj,
      work_hours: {
        ...settingsObj.work_hours,
        end_hour: value,
      },
    });
  };

  const handleSubmitSettings = async () => {
    const { data, error } = await supaClient
      .from("users")
      .update({
        timezone,
        settings: settingsObj,
      })
      .eq("slack_id", slackId);
    if (data) {
      message.success("Settings saved!");
    }
    if (error) {
      message.info("Please try again");
    }
  };

  return (
    <Card title="User settings" bordered={false}>
      <p>
        Daily summary on slack?{" "}
        <Switch checked={dailySummary} onChange={onDailySummary} />
      </p>
      <p>
        Weekly email digest?{" "}
        <Switch checked={weeklySummary} onChange={onWeeklySummary} />
      </p>
      <p className="font-bold mt-8">
        Working hours (for triggers / onboarding)
      </p>
      <div className="flex">
        <p>Select the Timezone:</p>
        <Select
          value={timezone}
          placeholder={!settingsObj.timezone ? "Not set" : timezone}
          style={{ width: "50%", marginLeft: "10px" }}
          onChange={handleChangeTimeZone}
          showSearch
        >
          {timezones.map((val: string) => (
            <Option key={val} value={val}>
              {val}
            </Option>
          ))}
        </Select>
      </div>
      <p>
        Start time:{" "}
        <InputNumber
          min={0}
          max={23}
          value={settingsObj.work_hours?.start_hour || undefined}
          onChange={handleChangeTimeStart}
        />
      </p>
      <p>
        End time:{" "}
        <InputNumber
          min={settingsObj.start_time + 1}
          max={47}
          value={settingsObj.work_hours?.end_hour}
          onChange={handleChangeTimeEnd}
        />
      </p>
      <div className="text-center">
        <Button type="primary" onClick={handleSubmitSettings}>
          Save
        </Button>
      </div>

      <br />
      <br />
      <p>
        Please contact us through chat or email if you want to change your
        default emojis.
      </p>
    </Card>
  );
}
